module.exports = __webpack_public_path__ + "img/1-low.455b2ec4.jpg";